<template>
	<component :is="view" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore, authUser } from '../store';
import Beschwerden from '@/views/Beschwerden.vue';
import BeschwerdenPublic from '@/views/BeschwerdenPublic.vue';

export default defineComponent({
	name: 'BeschwerdenWrapper',
	components: {
		Beschwerden,
		BeschwerdenPublic,
	},
	setup() {
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);
		const user = computed(() => store.state.user);
		const isLoggedIn = loggedin.value && user.value;

		const view = computed(() => {
			if (isLoggedIn) {
				return Beschwerden;
			} else {
				return BeschwerdenPublic;
			}
		});

		return {
			view,
		};
	},
});
</script>
